import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { GanttRow } from './GanttRow';
import { PlanGridHeader } from './PlanGridHeader';
export function PlanGrid({ rows, rowH, totalW, timelineW, weekW, metaCols, months, weeks, gridBackground, noResults, isEditor, onSelectRow, onStartEdit, onCommitCell, onCancelEdit, onOpenMenu, onDragStart, onDragOver, onDrop, onDragEnd, onPaintDown, onPaintMove, onSegDown, onSegClick, onSegDbl, onResizeDown, onGroupDown, onToggleTeam, onOpenSectionPopup, onCellClick, paintCursor, }) {
    return (_jsxs("div", { style: { width: totalW, minWidth: '100%' }, children: [_jsx(PlanGridHeader, { metaCols: metaCols, months: months, weeks: weeks, timelineW: timelineW, weekW: weekW }), noResults ? (_jsx("div", { style: {
                    position: 'sticky',
                    left: 0,
                    width: 420,
                    padding: '36px 24px',
                    fontSize: 13,
                    color: '#64748B',
                }, children: "\u041D\u0438\u0447\u0435\u0433\u043E \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u043E \u2014 \u0438\u0437\u043C\u0435\u043D\u0438\u0442\u0435 \u0437\u0430\u043F\u0440\u043E\u0441 \u0438\u043B\u0438 \u0444\u0438\u043B\u044C\u0442\u0440\u044B" })) : null, rows.map((row) => {
                if (row.isTeam) {
                    return (_jsx("div", { onClick: () => onToggleTeam(row.name), style: {
                            height: 30,
                            display: 'flex',
                            alignItems: 'center',
                            background: '#DCFCE7',
                            borderBottom: '1px solid #BBF7D0',
                            cursor: 'pointer',
                        }, children: _jsxs("div", { style: {
                                position: 'sticky',
                                left: 0,
                                display: 'flex',
                                alignItems: 'center',
                                gap: 8,
                                padding: '0 10px',
                                maxWidth: 560,
                            }, children: [_jsx("span", { style: { fontSize: 15, lineHeight: 1, color: '#15803D', width: 16, flex: 'none' }, children: row.chev }), _jsx("span", { style: { fontSize: 14, fontWeight: 700, color: '#14532D' }, children: row.name }), _jsx("span", { style: { fontSize: 11.5, color: '#4D7C5F' }, children: row.count })] }) }, `team-${row.name}`));
                }
                if (row.isSection) {
                    return (_jsx("div", { onClick: isEditor && row.sectionTeamIdx != null && row.sectionSecIdx != null
                            ? (e) => onOpenSectionPopup(row.sectionTeamIdx, row.sectionSecIdx, e)
                            : undefined, style: {
                            height: 24,
                            display: 'flex',
                            alignItems: 'center',
                            background: row.sectionBg ?? '#F0FDF4',
                            borderBottom: `1px solid ${row.sectionBorderColor ?? '#E7F6EC'}`,
                            cursor: isEditor ? 'pointer' : 'default',
                        }, children: _jsx("div", { style: {
                                position: 'sticky',
                                left: 0,
                                padding: '0 10px 0 32px',
                                fontSize: 11,
                                fontWeight: 600,
                                letterSpacing: '.05em',
                                color: row.sectionTextColor ?? '#166534',
                                whiteSpace: 'nowrap',
                            }, children: row.name }) }, `section-${row.sectionTeamIdx}-${row.sectionSecIdx}-${row.name}`));
                }
                if (row.isProject && row.id) {
                    return (_jsx(GanttRow, { row: row, rowH: rowH, timelineW: timelineW, gridBackground: gridBackground, isEditor: isEditor, onSelect: () => onSelectRow(row.id), onStartEdit: onStartEdit, onCommitCell: onCommitCell, onCancelEdit: onCancelEdit, onOpenMenu: onOpenMenu, onDragStart: onDragStart, onDragOver: onDragOver, onDrop: onDrop, onDragEnd: onDragEnd, onPaintDown: onPaintDown, onPaintMove: onPaintMove, onSegDown: onSegDown, onSegClick: onSegClick, onSegDbl: onSegDbl, onResizeDown: onResizeDown, onGroupDown: onGroupDown, onCellClick: onCellClick, paintCursor: paintCursor }, row.id));
                }
                return null;
            })] }));
}
